app.service('energyLabel', function (modal) {
	var lastModal = false;
	function open(img, alt) {
		modal.generate({
			id: 'energy-modal',
			content: '<img id="energy-label-img" src="' + img + '" alt="'+(alt || '')+'"/>',
			show: true,
			callbackClose: function () {
				if (lastModal) {
					if (modal.isExist(lastModal)) {
						modal.open(lastModal);
					} else {
						let $modal = $('#' + lastModal).remodal();
						$modal.open();
					}
					lastModal = false;
				}
			}
		});
	}
	let isOneInit = false;
	function init() {
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click', '.js-energy-label.with-energy-table', function (event) {
				let $currentModal = $('.remodal.remodal-is-opened');
				if ($currentModal.length) {
					lastModal = $currentModal.attr('id');
				} else {
					lastModal = false;
				}
	
				if ($(this).attr('href') != '#') {
					open($(this).attr('href'), $(this).data('alt'));
				}
				event.preventDefault();
				event.stopPropagation();
				UA.pageInteraction('Karta energetyczna', 'Emblemat');
			}).on('click', '.js-energy-card', function (event) {
				UA.pageInteraction('Karta energetyczna', 'Karta produktu');
			});
		}
	}
	return {
		init
	};
});
